"use client";

import { Switch, Text, Stack, Tokens } from "@chakra-ui/react";
import { memo, useMemo } from "react";

interface GenericToggleProps {
  label: string;
  description?: string;
  value?: boolean;
  onChange: (newValue: boolean) => void;
  disabled?: boolean;
  minW?: Tokens["sizes"];
  bgColor?: Tokens["colors"] | string;
}

function GenericToggleSetting({
  label,
  description,
  value = false,
  onChange,
  disabled = false,
  minW,
  bgColor = "moveon.secondaryLight",
}: GenericToggleProps) {
  // Resolve toggle background color based on value
  const toggleColor = useMemo(() => {
    const color = value ? bgColor : "moveon.inactive";
    return color as Tokens["colors"] | string;
  }, [bgColor, value]);

  return (
    <Stack align="start" direction={{ base: "column", md: "row" }}>
      <Switch.Root
        minW={minW}
        checked={value}
        disabled={disabled}
        onCheckedChange={(details) => onChange(details.checked)}
      >
        <Switch.HiddenInput />
        <Switch.Control bg={toggleColor}>
          <Switch.Thumb />
        </Switch.Control>
        <Switch.Label>{label}</Switch.Label>
      </Switch.Root>

      {description && <Text fontSize="sm">{description}</Text>}
    </Stack>
  );
}

// Wrap in React.memo for performance optimization
const GenericToggle = memo(GenericToggleSetting);
export default GenericToggle;
